import React from "react";
import { motion } from "framer-motion";
//* importing styles
import { StyleContainer } from "./Home.styled/Hero.styled";

import images from "../../constants/images";
import HiEmoji from "../../assets/animated/HiEmoji";

import {
  AiFillTwitterCircle,
  AiOutlineGithub,
  AiFillLinkedin,
  AiOutlineInstagram,
  AiOutlineCloudDownload,
} from "react-icons/ai";

import {
  animateImg1,
  animateImg2,
  animateImg3,
  animateImg4,
  animateImg5,
  animateImg6,
  animateImg7,
  animateImg8,
  animateImg9,
  animateImg10,
  animateImg11,
  animateImg12,
  animateImg13,
  animateImg14,
  animateImg15,
  animateImg16,
  animateImg17,
  animatebuyCoffee,
} from "./Animate/Home.Animate";
import { SiBuymeacoffee } from "react-icons/si";

const Home = () => {
  return (
    <StyleContainer id="home">
      <div className="hero-text__section">
        <div className="text-content">
          <div className="name">
            <HiEmoji />
            <div className="Name">
              <span>Praise Leye</span>
            </div>
          </div>

          <div className="skillset">
            <span>FULL STACK (MERN) DEVELOPER. </span>{" "}
            <span>
              I Build Scalable, Responsive Web Apps highly optimised by
              leveraging on modern Javascript frameworks and technologies.
            </span>
          </div>

          <button className="downloadCV">
            <a href={images.Resume} download="Praiz's CV">
              <div>Download CV</div> <AiOutlineCloudDownload />
            </a>
          </button>
        </div>
      </div>
      {/* End of Hero Text section */}

      <div className="hero-img__container">
        <table>
          <tbody>
            <tr>
              <td>
                <motion.img
                  src={images.DcoDerImage_03}
                  width="195"
                  height="154"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg1}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_04}
                  width="196"
                  height="154"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg2}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_05}
                  width="195"
                  height="154"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg3}
                />
              </td>
            </tr>
          </tbody>

          <tbody>
            <tr>
              <td>
                <motion.img
                  src={images.DcoDerImage_10}
                  width="195"
                  height="153"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg4}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_11}
                  width="196"
                  height="153"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg5}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_12}
                  width="195"
                  height="153"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg6}
                />
              </td>
            </tr>
          </tbody>

          <tbody>
            <tr>
              <td>
                <motion.img
                  src={images.DcoDerImage_17}
                  width="195"
                  height="154"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg7}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_18}
                  width="196"
                  height="154"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg8}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_19}
                  width="195"
                  height="154"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg9}
                />
              </td>
            </tr>
          </tbody>

          <tbody>
            <tr>
              <td>
                <motion.img
                  src={images.DcoDerImage_24}
                  width="195"
                  height="153"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg10}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_25}
                  width="196"
                  height="153"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg11}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_26}
                  width="195"
                  height="153"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg12}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_27}
                  width="195"
                  height="153"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg13}
                />
              </td>
            </tr>
          </tbody>

          <tbody>
            <tr>
              <td>
                <motion.img
                  src={images.DcoDerImage_31}
                  width="195"
                  height="154"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg14}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_32}
                  width="196"
                  height="154"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg15}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_33}
                  width="195"
                  height="154"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg16}
                />
              </td>
              <td>
                <motion.img
                  src={images.DcoDerImage_34}
                  width="195"
                  height="154"
                  alt="grouped-pic of myself"
                  initial="hidden"
                  animate="visible"
                  variants={animateImg17}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="hero-aside__section">
        <div className="hero-aside__text">
          Transforming Imaginations to Reality.{" "}
          <div>
            <a href="#contact"> CONTACT ME. </a>
          </div>
        </div>
        <div className="social-links">
          <a
            href="https://twitter.com/Praiz_DcoDer"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AiFillTwitterCircle />
            <div>Twitter</div>
          </a>
          {/* <AiOutlineWhatsApp /> */}
          <a
            href="https://github.com/Praizleye"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AiOutlineGithub />
            <div>Github</div>
          </a>

          <a
            href="https://www.linkedin.com/in/praise-ogunleye-bb9244199"
            target="_blank"
            rel="noopener noreferrer"
          >
            <AiFillLinkedin />
            <div>LinkedIn</div>
          </a>
          <a href="#Blanks">
            <AiOutlineInstagram />
            <div>Instagram</div>
          </a>
        </div>
        <div>
          <div className="buyCoffee" id="buyCoffee">
            <motion.div variants={animatebuyCoffee} whileInView="animate">
              <SiBuymeacoffee />
            </motion.div>
            <a
              href="https://www.buymeacoffee.com/praizDcoDer"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="btn-buyCoffee">Buy me a Coffee</button>
            </a>
          </div>
        </div>
      </div>
    </StyleContainer>
  );
};

export default Home;
